import { render, staticRenderFns } from "./QuestionnaireSidebar.vue?vue&type=template&id=38fa0aec&scoped=true&lang=pug"
import script from "./QuestionnaireSidebar.vue?vue&type=script&lang=ts"
export * from "./QuestionnaireSidebar.vue?vue&type=script&lang=ts"
import style0 from "./QuestionnaireSidebar.vue?vue&type=style&index=0&id=38fa0aec&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fa0aec",
  null
  
)

export default component.exports